export const columns = (vm) =>{
    return [
        {
            label:'',
            width:50,
            headerAlign:"center",
            align:"center",
            type:'selection',
        },
        {
            label:'产品图片',
            prop:'policeName',
            width:120,
            render: (h, params) => {
               let IMGBLOCK = (h)=>{
                   return h('el-image',{
                    props:{
                        lazy:true,
                        src:params.row.imageUrl,
                        previewSrcList:[params.row.imageUrl]
                    },
                    style:{
                        width:"35px",
                        height:"35px",
                        borderRadius:"4px",
                        position: "relative",
                        top:"5px"
                    }
                   })
               }
               return h('div',{class:"common-items-center,common-space-around"},[IMGBLOCK(h)])
            }
        },
        {
            label:'产品名称',
            prop:'name',
            tooltip:true,
            render: (h, params) => {
                const look = (h) => {
                    return h('span', {
                          props: {
                              type:'primary',
                              size:"mini"
                          },
                          style: {
                            color:"#458EFF",
                            cursor:"pointer"
                          },
                          on: {
                            click: () => {
                                vm.openProduct(params.row);
                            }
                        }
                      }, params.row.name);
                };
                return h('div',{}, [look(h)])
            }
        },
        {
            label:'设备分类',
            prop:'deviceTypeName',
            width:160,
            tooltip:true
        },
        {
            label:'企业名称',
            prop:'factoryName',
            tooltip:true
        },
        // {
        //     label:'工程商',
        //     prop:'deviceTypeName',
        //     width:160,
        //     tooltip:true,
        //     render: (h, params) => {
        //         return h('div',{},"陈卓璇")
        //     }
        // },
        // {
        //     label:'电话',
        //     prop:'deviceTypeName',
        //     width:160,
        //     render: (h, params) => {
        //         return h('div',{},"13882808105")
        //     }
        // },
        {
            label:'已安装数量',
            prop:'deviceInstalledCount',
            align:"center",
            headerAlign:"center",
            tooltip:true
        },
        {
            label:'更新时间',
            width:160,
            render: (h, params) => {
                return h('span',{},!params.row.updateTime ? params.row.createTime:params.row.updateTime)
            }
        },
        {
            label:'状态',
            width:160,
            align:"center",
            headerAlign:"center",
            render: (h, params) => {
                const look = (h) => {
                    return h('span', {
                          props: {
                              type:'primary',
                              size:"mini"
                          },
                          style: {
                            color:"#458EFF",
                            cursor:"pointer"
                          },
                          on: {
                            click: () => {
                                vm.openImei(params.row);
                            }
                        }
                      },"查看");
                };
                return h('div',{}, [look(h)])
            }
        }
    ]
}